<template>
  <component :is="layout">
    <router-view></router-view>
  </component>
</template>

<script>
// import axios from "axios";
import EmptyLayout from "@/layouts/EmptyLayout";
import FormLayout from "@/layouts/FormLayout";
import MainLayout from "@/layouts/MainLayout";
// import { mapGetters, mapActions} from 'vuex'
// import dayjs from 'dayjs'
// import jwt_decode from "jwt-decode";

export default {
  components: {
    EmptyLayout,
    FormLayout,
    MainLayout,
  },
  computed: {
    layout() {
      return this.$route.meta.layout || 'empty-layout'
    }
  },
  // methods: {
  //   ...mapActions({
  //     updateToken: 'authorization/updateToken',
  //   }),
  // },
  watch: { 
    '$route': () => {
      const bodyElem = document.querySelector('body') 
      bodyElem.classList.contains('menu-open') && bodyElem.classList.remove("menu-open")
      bodyElem.classList.contains('assistant-open') && bodyElem.classList.remove("assistant-open")
    }
  },
  // created() {
  //   // setInterval(() => {
  //   //   //  const AccessTokenTimestamp = localStorage.getItem('access_token_timestamp')
  //   //   const access = localStorage.getItem('access-token')
  //   //     if (access){
  //   //       const user = jwt_decode(access)
  //   //       const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;
  //   //       if(isExpired){
  //   //         this.updateToken();
  //   //       }
  //   //     }
  //   // }, 60000);
  //   // axios.interceptors.request.use(async (config) => {
  //   //     const AccessTokenTimestamp = localStorage.getItem('access_token_timestamp')

  //   //     if(AccessTokenTimestamp && ((+new Date() - AccessTokenTimestamp) < 240000)){
  //   //       // this.updateToken();
  //   //       console.log('sd')
  //   //     }
  //   //     return config
  //   //   }, async (error) => {
  //   //     // Do something with request error
  //   //     return Promise.reject(error);
  //   //   }
  //   // );

  //   axios.interceptors.request.use((conf) => {
  //     const access = localStorage.getItem('access-token') || '';
  //     if (access){
  //       const user = jwt_decode(access)
  //       const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;
  //       if(isExpired){
  //         this.updateToken();
  //         return conf;
  //       }
  //       return conf;
  //     }
  //     return conf;
  //   }, (error) => {
  //     // Do something with request error
  //     return Promise.reject(error);
  //   });
  // }
}
</script>

<style>

</style>
